import { render, staticRenderFns } from "./DrawerMenuCamadasTreeItem.vue?vue&type=template&id=5e1bd821&lang=pug"
import script from "./DrawerMenuCamadasTreeItem.vue?vue&type=script&lang=js"
export * from "./DrawerMenuCamadasTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports